export const PARTNER_CLAIM_ADD_ITEM = 'partner.claim.add_item'
export const PARTNER_CLAIM_BRANDING = 'partner.claim.branding'
export const PARTNER_REPAIRS_REPAIR_FIRST = 'partner.repairs.repair_first'
export const PARTNER_REPAIRS_REGULAR_REPAIR = 'partner.repairs.regular_repair'
export const ALLOW = 'ALLOW'
export const DISALLOW = 'DISALLOW'
